import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairBreakingToServer } from "./mappers/mapRepairBreakingToServer";

export const removeRepairBreaking = async (sessionKey, breaking) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/remove/broken`,
            method: "DELETE",
            data: mapRepairBreakingToServer(breaking),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
